import {defineMessages} from 'react-intl';

export const callSurfaceMessages = defineMessages({
    pillLabel: {id: 'callSurface.pill.label', defaultMessage: 'Start a call…'},
    pillAria: {id: 'callSurface.pill.aria', defaultMessage: 'Start a call'},
    pillMove: {id: 'callSurface.pill.move', defaultMessage: 'Move the call button'},
    pillDragHint: {id: 'callSurface.pill.drag-hint', defaultMessage: 'Drag to move, or click to pick a corner'},
    pillCorners: {id: 'callSurface.pill.corners', defaultMessage: 'Move the call button to'},
    pillCornerTopLeft: {id: 'callSurface.pill.corner.top-left', defaultMessage: 'Top left'},
    pillCornerTopRight: {id: 'callSurface.pill.corner.top-right', defaultMessage: 'Top right'},
    pillCornerBottomLeft: {id: 'callSurface.pill.corner.bottom-left', defaultMessage: 'Bottom left'},
    pillCornerBottomRight: {id: 'callSurface.pill.corner.bottom-right', defaultMessage: 'Bottom right'},
    dialerRegion: {id: 'callSurface.dialer.region', defaultMessage: 'Dialer'},
    closeDialer: {id: 'callSurface.dialer.close', defaultMessage: 'Close dialer'},
    unknownCaller: {id: 'callSurface.identity.unknown', defaultMessage: 'Unknown'},
    callEnded: {id: 'callSurface.ended.title', defaultMessage: 'Call ended'},
    callEndedDuration: {id: 'callSurface.ended.duration', defaultMessage: 'Call ended · {duration}'},
    callDeclined: {id: 'callSurface.ended.declined', defaultMessage: 'Declined'},
    callBusy: {id: 'callSurface.ended.busy', defaultMessage: 'In another call'},
    callBack: {id: 'callSurface.ended.callBack', defaultMessage: 'Call back'},
    close: {id: 'callSurface.ended.close', defaultMessage: 'Close'},
    endedRegion: {id: 'callSurface.ended.region', defaultMessage: 'Call with {name} ended'},
    waitingRegion: {id: 'callSurface.waiting.region', defaultMessage: 'Second incoming call while on a call with {name}'},
    manyRegion: {id: 'callSurface.many.region', defaultMessage: '{count} incoming calls'},
    manyTitle: {id: 'callSurface.many.title', defaultMessage: '{count} incoming calls'},
    onCall: {id: 'callSurface.waiting.on-call', defaultMessage: 'On call · {timer}'},
    onCallNoTimer: {id: 'callSurface.waiting.on-call-no-timer', defaultMessage: 'On call'},
    incomingCall: {id: 'callSurface.waiting.incoming', defaultMessage: 'Incoming call'},
    incomingVideoCall: {id: 'callSurface.waiting.incoming-video', defaultMessage: 'Incoming video call'},
    incomingOnLine: {id: 'callSurface.waiting.incoming-line', defaultMessage: 'Incoming call · {line}'},
    decline: {id: 'callSurface.waiting.decline', defaultMessage: 'Decline'},
    holdAndAccept: {id: 'callSurface.waiting.hold-accept', defaultMessage: 'Hold & accept'},
    endAndAccept: {id: 'callSurface.waiting.end-accept', defaultMessage: 'End current call and accept'},
    declineAll: {id: 'callSurface.many.decline-all', defaultMessage: 'Decline all'},
    declineName: {id: 'callSurface.many.decline-name', defaultMessage: 'Decline {name}'},
    acceptName: {id: 'callSurface.many.accept-name', defaultMessage: 'Accept {name}'},
    onHold: {id: 'callSurface.held.on-hold', defaultMessage: 'On hold · {timer}'},
    onHoldNoTimer: {id: 'callSurface.held.on-hold-no-timer', defaultMessage: 'On hold'},
    swap: {id: 'callSurface.held.swap', defaultMessage: 'Swap'},
    swapAria: {id: 'callSurface.held.swap-aria', defaultMessage: 'Swap to {name}'},
});
